import { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { ItemMenu } from "../../store/useSidebar/model";
import { navigateToClub } from "../../utils/club";
import Icon from "../Icon/Icon";

import styles from "./Tree.module.scss";

interface Props {
    data: ItemMenu[];
    className?: string;
}

const Tree = ({ data, className }:Props) => {
  return (
    <div className={className}>
      <ul className="d-flex d-tree-container flex-column">
        {data?.map((tree) => (
          <TreeNode key={tree.key} node={tree} />
        ))}
      </ul>
    </div>
  );
};

interface ItemTreeNode {
    node: ItemMenu
}

const TreeNode = ({ node }: ItemTreeNode) => {
  const navigate= useNavigate()
  const [childVisible, setChildVisiblity] = useState(false);
  const hasChild = node.children ? true : false;
  
  return (
    <li key={node.key} className="d-tree-node border-0" style={{ cursor: 'pointer' }}>
      <div className={styles.dFlex} onClick={(e) => (setChildVisiblity((v) => !v))}>
        <>
          {node.icon && <Icon icon={node.icon}/>}
          {
            node?.to ?
              <NavLink
              key={node.key} 
              to={node?.to}
              className={styles.link}
            >
              {node.label}
              </NavLink>
              :
              <label className={styles.link}>{node.label}</label>
          }
        </>
      </div>

      {hasChild && childVisible && (
        <Tree data={node.children} />
      )}
    </li>
  );
};

export default Tree;